import React, { Component } from 'react'
import './index.less'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import CountDown from 'src/component/CountDown'
import { inject, observer } from 'src/core/store'

@inject('store')
@observer

export default class extends Component {
  state = {
    lang: langM.en,
    language: 'zh'
  }

  constructor(props) {
    super(props)
    this.reStore = this.props.store.register('app/rechargebonus')
  }

  async componentDidMount() {
    setDocumentTitle('Recharge Bonus')
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    console.log(this.props.location.query)
    language =await getlang(language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  RunOnStart = async (uid) => {
    await this.reStore.getCd()
  }

  render() {
    let { lang, language } = this.state
    let { cd } = this.reStore.data
    return (
      <div className="recharge-bonus-main">
        <div className={`recharge-bonus-wrap ${isRtl(language) && 'arlang'}`}>
          <div className="br-bg">
            <div className="gold1"></div>
            <div className="gold2"></div>
            <div className="title">
              <CountDown lang={lang} language={language} leftTimestamp={cd}></CountDown>
            </div>
            <div className="r-content">
              <div className="tit">
                {lang.title}
              </div>
              <div className="txt">
                {lang.txt1}
              </div>
              <div className="txt2">
                {lang.txt2}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/app/rechargebonus/index.js